module.exports = __webpack_public_path__ + "img/logo_stregis_b@3x.74dc2a69.png";